'use client';

import { useMemo } from 'react';
import type { Property } from '@/lib/api/clients/properties';
import { mockProperties } from '@/lib/mock-properties';
import { AllysPropertyListing } from '@routeroyal/theme-allys';

const SLUG_TO_CODE: Record<string, string> = {
  villa: 'VILLA',
  residential: 'RESIDENTIAL',
  apartment: 'APARTMENT',
  commercial: 'COMMERCIAL',
  land: 'LAND',
  house: 'HOUSE',
  penthouse: 'PENTHOUSE',
};

type Props = {
  properties: Property[];
  organisationId: string;
  locale: string;
  messages: Record<string, unknown>;
  basePath: string;
  /** Property type slug from URL (e.g. "villa", "land") to pre-filter listings */
  initialPropertyTypeSlug?: string | null;
};

export function PropertiesContentAllys({ 
  properties, 
  organisationId, 
  locale, 
  messages,
  basePath,
  initialPropertyTypeSlug = null,
}: Props) {
  const initialPropertyTypeId = useMemo(() => {
    if (!initialPropertyTypeSlug) return null;
    const code = SLUG_TO_CODE[initialPropertyTypeSlug.toLowerCase()];
    if (!code) return null;
    const match = properties.find(p => p.propertyType?.code?.toUpperCase() === code);
    return match?.propertyType?.id ?? null;
  }, [initialPropertyTypeSlug, properties]);

  return (
    <>
      <AllysPropertyListing
        organisationId={organisationId}
        locale={locale as 'en' | 'es' | 'fr'}
        messages={messages}
        initialView='grid'
        showMapView={false}
        initialProperties={properties}
        fallbackProperties={mockProperties}
        basePath={basePath}
        initialPropertyTypeId={initialPropertyTypeId}
      />
    </>
  );
}
